import { isPressureValueType } from 'App/Map/CurrentValuesMap/_utils/by-domain/_utils/isPressureValueType'
import { NDVI } from 'App/Map/CurrentValuesMap/components/SelectedMapCard/components/NDVI'
import { PointVendorIcons } from 'App/Map/CurrentValuesMap/components/SelectedMapCard/components/PointVendorIcons'
import { Trap } from 'App/Map/CurrentValuesMap/components/SelectedMapCard/components/Trap'
import { WindMachine } from 'App/Map/CurrentValuesMap/components/SelectedMapCard/components/WindMachine'
import { ZoneVendorIcons } from 'App/Map/CurrentValuesMap/components/SelectedMapCard/components/ZoneVendorIcons'
import { MapCard } from 'components/MapCard/MapCard'
import { useCallback } from 'react'
import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { mapSelectedCardStore } from 'stores/mapSelectedCardStore/mapSelectedCardStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { cardCSSAboveDetailsPanel } from './_utils/cardCSSAboveDetailsPanel'
import { IrrigationActivityTooltip } from './components/IrrigationActivityTooltip'

const ENABLE_WIP_CARDS = false

export const SelectedMapCard: React.FC = () => {
  const mapSelectedCardStoreState = mapSelectedCardStore.useSelector((s) => s)
  const visible = Object.keys(mapSelectedCardStoreState).length > 0
  const onClose = useCallback(() => mapSelectedCardStore.actions.hide(), [])
  const rainUnit = userDetailsStore.useSelector((s) => s.rain)
  const pressureUnit = userDetailsStore.useSelector((s) => s.pressure)

  const irrigationActivityPressureValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup.POINT.irrigation_activity_pressure?.valueType,
  )

  const irrigationActivityZonesValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup.IRRIGATION_ZONE?.irrigation_activity_zones?.valueType,
  )

  if (!visible) return null

  if (ENABLE_WIP_CARDS && !HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD && mapSelectedCardStoreState.metaBlock) {
    return (
      <MapCard
        latLng={mapSelectedCardStoreState.metaBlock.latLng.toJSON()}
        title={mapSelectedCardStoreState.metaBlock.blockName}
        onClose={onClose}
        footer={null}
      >
        {null}
      </MapCard>
    )
  }

  if (!HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD && mapSelectedCardStoreState.metaStation?.irrigationActivity) {
    const valueTypeIsForStatus = irrigationActivityPressureValueType === 'irrigationIsOn_status'

    return (
      <MapCard
        key={`station-${rainUnit}-${pressureUnit}-${irrigationActivityPressureValueType}`}
        latLng={mapSelectedCardStoreState.metaStation.latLng.toJSON()}
        title={mapSelectedCardStoreState.metaStation.name}
        titleIcons={
          <PointVendorIcons
            propertyId={mapSelectedCardStoreState.metaStation.propertyId}
            lngLat={mapSelectedCardStoreState.metaStation.lngLat}
          />
        }
        onClose={onClose}
        footer={null}
        popoverWidth={valueTypeIsForStatus ? 250 : 350}
        cardCSS={cardCSSAboveDetailsPanel}
      >
        <IrrigationActivityTooltip
          emitters={mapSelectedCardStoreState.metaStation?.irrigationActivity}
          valueTypeIsForStatus={valueTypeIsForStatus}
          valueTypeIsForPressure={isPressureValueType(irrigationActivityPressureValueType)}
        />
      </MapCard>
    )
  }

  if (
    !HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD &&
    mapSelectedCardStoreState.metaIrrigationActivityZone?.irrigationActivity
  ) {
    const valueTypeIsForStatus = irrigationActivityZonesValueType === 'irrigationIsOn_status'

    return (
      <MapCard
        key={`zone-${rainUnit}-${irrigationActivityZonesValueType}`}
        latLng={mapSelectedCardStoreState.metaIrrigationActivityZone.latLng.toJSON()}
        title={mapSelectedCardStoreState.metaIrrigationActivityZone.irrigationZoneName}
        titleIcons={
          <ZoneVendorIcons
            propertyId={mapSelectedCardStoreState.metaIrrigationActivityZone.propertyId}
            irrigationZoneEmitterId={
              mapSelectedCardStoreState.metaIrrigationActivityZone.irrigationZoneEmitterId
            }
          />
        }
        onClose={onClose}
        footer={null}
        popoverWidth={valueTypeIsForStatus ? 250 : 350}
        cardCSS={cardCSSAboveDetailsPanel}
      >
        <IrrigationActivityTooltip
          emitters={mapSelectedCardStoreState.metaIrrigationActivityZone?.irrigationActivity}
          valueTypeIsForStatus={valueTypeIsForStatus}
        />
      </MapCard>
    )
  }

  if (mapSelectedCardStoreState.metaWindMachine) {
    return <WindMachine {...mapSelectedCardStoreState.metaWindMachine} onClose={onClose} />
  }

  if (!HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD && mapSelectedCardStoreState.metaNdvi) {
    return (
      <NDVI
        {...mapSelectedCardStoreState.metaNdvi}
        key={mapSelectedCardStoreState.metaNdvi.blockId}
        onClose={onClose}
      />
    )
  }

  if (mapSelectedCardStoreState.metaTrap) {
    return (
      <Trap
        {...mapSelectedCardStoreState.metaTrap}
        key={mapSelectedCardStoreState.metaTrap.lngLat}
        onClose={onClose}
      />
    )
  }

  return null
}
